import React from "react"
import { useSelector } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';
import { toChatContent, toChatTypeLabel, toMessageTypeLabel } from './ChatHistory';
import { currentUserSelector } from "store/current_user"
import styles from 'styles/admin-detail.module.scss';
import { isPermitted } from 'utils/utils';

import VehicleInspectionCertImage from "components/VehicleInspectionCertImage"

const ChatHistoryDetail = ({ chatHistory, detailData, closeModal }) => {

  const currentUser = useSelector(currentUserSelector)

  return (
    <>
      <CloseIcon
        fontSize='large'
        className={styles.closeImg}
        onClick={closeModal}
      />
      <div className={styles.confirmPage}>
        <div className={styles.confirmPageTitle}> 送信内容</div>
        <div className={styles.confirmPageItemArea}>
          <div className={styles.confirmPageItem}>
            <p className={styles.labelTop}>チャット種別</p>
            <p className={styles.text}>
              {toMessageTypeLabel(chatHistory?.type, chatHistory?.messageType)}
            </p>
          </div>
          <div className={styles.confirmPageItem}>
            <p className={styles.labelTop}>LINEメッセージ</p>
            <p className={styles.text}>
              {chatHistory?.freeMessage}
            </p>
          </div>
          {(chatHistory.type !== 2) && (
            <>
              <div className={styles.confirmPageItem}>
                <p className={styles.labelTop}>回答フォーム種別</p>
                <p className={styles.text}>
                  {toChatTypeLabel(chatHistory?.type)}
                </p>
              </div>
              <div className={styles.confirmPageItem}>
                <p className={styles.labelTop}>回答フォームメッセージ</p>
                <p className={styles.text}>
                  {chatHistory?.message}
                </p>
              </div>
            </>
          )}
        </div>
        {(chatHistory.type !== 2) && (
          <>
            <div className={styles.confirmPageTitle}>回答</div>
            <div className={styles.confirmPageItemArea}>
              <div className={styles.confirmPageItem}>
                <p className={styles.labelTop}>回答結果</p>
                <p className={styles.text}>
                  {toChatContent(chatHistory)}
                </p>
              </div>

              {(chatHistory.type === 5 || chatHistory.type === 7) && (
                <div className={styles.confirmPageItem}>
                  <p className={styles.labelTop}>回答内容</p>
                  <p className={styles.text}>
                    {chatHistory.acceptanceStatus === 1 ? "-" : chatHistory.answerWithFreeText}
                  </p>
                </div>
              )}
              {(chatHistory.type === 6 || chatHistory.type === 7) && chatHistory.acceptanceStatus !== 1 && (
                <div className={styles.confirmPageItem}>
                  <VehicleInspectionCertImage title="アップロード済み画像"
                    s3FileName={chatHistory?.vehicleInspectionCertImgPath}
                    isPrintButtonDisabled={!isPermitted(currentUser, detailData.lockedBy)}
                  />
                </div>
              )}
              {chatHistory.furtherQuestions && (
                <div className={styles.confirmPageItem}>
                  <p className={styles.labelTop}>確認事項</p>
                  <p className={styles.text}>
                    {chatHistory.furtherQuestions}
                  </p>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ChatHistoryDetail;
